import { useIntl } from "react-intl";

const AuditLogs = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AuditLogs.header",
            defaultMessage: "Audit logs"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AuditLogs.body",
            defaultMessage:
                "Audit logs let administrators look at changes made to your site. This is useful when you need to troubleshoot a problem or keep a record of important events, like changes to global permissions."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default AuditLogs;
